(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo/assets/javascripts/marionette/nyxclientinterface.js') >= 0) return;  svs.modules.push('/modules/bingo/assets/javascripts/marionette/nyxclientinterface.js');

(function(svs) {
  svs.bingo.NyxClientInterfaceClass = function(bingoModuleName) {
    var self = this;

    this.bingoModuleName = bingoModuleName;

    return {
      init: function() {
        this.WAGER_PAID = 0;
        this.ON_GAME_FINISHED = 1;
        this.GAME_LOADED = 6;
      },

      loadGame: function(wagerId) {
        if (typeof self.bingoClient !== 'object') {
          self.bingoClient = this.makePath(self.bingoModuleName);
        }
        self.bingoClient.loadBingoWagerByReference(wagerId);
        svs.bingo.router.navigate('mina-spel/pagaende/' + wagerId, {
          trigger: false
        });
      },

      makePath: function(moduleName) {
        var path = null;
        if (path == null && typeof window.swfobject == 'object') {
          path = window.swfobject.getObjectById(moduleName);
        }
        if (path == null) {
          path = window[moduleName];
        }
        if (path == null) {
          path = document[moduleName];
        }

        if (path == undefined) {
          path = document.getElementById(moduleName);
        }

        return path;
      },

      doLogon: function() {
        var props = {};

        if (typeof self.bingoClient !== 'object') {
          self.bingoClient = this.makePath(self.bingoModuleName);
        }

        if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
          if (!svs.core.detect.formfactor.mobile()) {
            self.bingoClient.doLoginExternal(props);
          }
        }
      },

      doLogout: function() {
        if (typeof self.bingoClient !== 'object') {
          self.bingoClient = this.makePath(self.bingoModuleName);
        }
        if (!svs.core.detect.formfactor.mobile()) {
          self.bingoClient.doLogout();
        }
      },

      clientCallBack: function(evt, params) {
        if (params.rc === 1019) {
          evt = 'CUSTOMER_SUSPENDED';
        } else if (
          params.rc === 1016 ||
          (params.message &&
            Boolean(~params.message.indexOf('Spelet har redan startat.')))
        ) {
          evt = 'GAME_ALREADY_STARTED';
        }
        switch (evt) {
          case 'CLIENT_READY':
            this.doLogon();
            self.bingoClient.updateSettings({
              sounds: 'on',
              music: 'off',
              caller: 'on'
            });
            break;

          case 'BINGO_GAME_LOADED':
            self.gameConfig = params.gameconfig || {};
            if (!svs.bingo.data.activeWagers) {
              svs.bingo.router.navigate('spela/' + params.gameid);
            }
            break;

          case 'BINGO_GAME_ON_END_WAGER':
            svs.components.account_balance.get(true);
            svs.bingo.nyxChannel.trigger('GameCompleted');
            break;

          case 'BINGO_GAME_ON_WAGER':
            var stat = {
              gameId: self.gameConfig.gameId,
              gameName: self.gameConfig.namet,
              gameModel: self.gameConfig.Model,
              betAmount: params.bet || undefined,
              wagerId: params.wagerid || undefined
            };

            svs.bingo.nyxChannel.request('sendStatistics', stat);
            svs.components.account_balance.get(true);
            break;

          case 'CASINO_GAME_ON_WAGER':
            svs.components.account_balance.get(true);
            svs.bingo.nyxChannel.request('destroyClient', stat);
            break;
          case 'CASINO_GAME_ON_END_WAGER':
            svs.components.account_balance.get(true);
            break;

          case 'BINGO_GAME_CANCELLED':
            svs.components.account_balance.get(true);
            break;

          case 'CUSTOMER_SUSPENDED':
            svs.lbUtils.wager.showSuspensionMessage();
            break;

          case 'GAME_ALREADY_STARTED':
            break;

          case 'PROMPT_ERROR_MSG':
            if (
              params.rc === 1002 ||
              params.rc === 12000 ||
              Boolean(~params.message.indexOf('INVALID SESSION')) ||
              Boolean(~params.message.indexOf('Det gick inte att logga in.'))
            ) {
              svs.core.userSession.logout(
                function() {
                  svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
                    branding: svs.ui.dialog.branding.SPORT,
                    title: 'Du har blivit utloggad',
                    icon: 'login',
                    area: svs.ui.dialog.area.POPUP,
                    type: svs.ui.dialog.type.CONFIRM,
                    message: [
                      {
                        type: svs.ui.dialog.message.TEXT,
                        text: 'Din inloggade sessionstid har nämligen överskridits.'
                      }
                    ],
                    actions: [
                      {
                        title: 'Ok'
                      }
                    ]
                  }));
                },
                function() {
                  svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
                    branding: svs.ui.dialog.branding.SPORT,
                    title: 'Tekniskt fel',
                    icon: 'help-2',
                    area: svs.ui.dialog.area.POPUP,
                    type: svs.ui.dialog.type.CONFIRM,
                    message: [
                      {
                        type: svs.ui.dialog.message.TEXT,
                        text: 'Vi jobbar för fullt med att åtgärda felet. Välkommen tillbaka lite senare.'
                      }
                    ],
                    actions: [
                      {
                        title: 'Ok'
                      }
                    ]
                  }));
                }
              );
              svs.bingo.router.navigate('/', { trigger: true });
            }
            if (
              ~params.message.indexOf('Du har inte tillräckligt med pengar på ditt spelkonto.')
            ) {
              break;
            }
            break;
          case 'GO_TO_HOME_PAGE':
            svs.bingo.router.navigate('/', { trigger: true });
            break;

          case 'GO_TO_SIGNUP_PAGE':
            location.href = svs.core.urlMapping.get('customerRegistrationHome');
            break;

          case 'GO_TO_BINGO_GAME':
            break;
          default:
        }
      }
    };
  };
})(svs);


 })(window);